enum BuildingFoundationDetailType {
	CRAWL_SPACE_PARTIAL_ENCLOSURE = 'CrawlSpacePartialEnclosure',
	CRAWL_SPACE_WITH_ENCLOSURE = 'CrawlSpaceWEnclosure',
	CRAWL_SPACE_WITHOUT_ENCLOSURE = 'CrawlSpaceWOEnclosure',
	ELEVATED_FLOOR_PARTIAL_ENCLOSURE = 'ElevatedFloorPartialEnclosure',
	ELEVATED_FLOOR_WITH_ENCLOSURE = 'ElevatedFloorWEnclosure',
	ELEVATED_FLOOR_WITHOUT_ENCLOSURE = 'ElevatedFloorWOEnclosure',
	FULL_BASEMENT = 'FullBasement',
	RAISED_SLAB = 'RaisedSlab',
	SLAB_ON_GRADE_DETAIL = 'SlabOnGradeDetail',
	SUBGRADE_CRAWL_SPACE = 'SubgradeCrawlSpace',
	WALKOUT_BASEMENT = 'WalkoutBasement',
}

export default BuildingFoundationDetailType;